const getAllTaskInitialState = {
  users: [],
  loading: false,
  error: null,
  currentPage: 1,
  itemsPerPage: 30,
  totalPages: 0,

  task_deadlines: false,
  prioritet: false,
  status: false,
  price: false,

  activeRequestId: null,
};

const firstTask = (item) => {
  const task =
    Array.isArray(item?.alltask) && item.alltask.length ? item.alltask[0] : null;

  return task || {};
};

const parseDate = (value) => {
  const date = new Date(value).getTime();
  return Number.isFinite(date) ? date : Number.MAX_SAFE_INTEGER;
};

const applySorting = (users, state) => {
  const list = Array.isArray(users) ? [...users] : [];

  if (state.task_deadlines) {
    list.sort(
      (a, b) => parseDate(firstTask(a).endDate) - parseDate(firstTask(b).endDate)
    );
  }

  if (state.prioritet) {
    const order = {
      Критический: 3,
      Важно: 2,
      Срочно: 1,
      Низший: 0,
    };

    list.sort(
      (a, b) =>
        (order[firstTask(b).prioritet] ?? -1) -
        (order[firstTask(a).prioritet] ?? -1)
    );
  }

  if (state.status) {
    const order = {
      Новая: 5,
      Возвращена: 4,
      Выполняется: 3,
      Выполнена: 2,
      Отменено: 1,
      Закрыта: 0,
    };

    list.sort(
      (a, b) =>
        (order[firstTask(b).status] ?? -1) -
        (order[firstTask(a).status] ?? -1)
    );
  }

  if (state.price) {
    list.sort(
      (a, b) => Number(firstTask(b).price || 0) - Number(firstTask(a).price || 0)
    );
  }

  return list;
};

const cloneDeep = (value) => JSON.parse(JSON.stringify(value));

const setByPath = (object, path, value) => {
  const draft = cloneDeep(object);
  const parts = String(path).split(".");
  let cursor = draft;

  for (let index = 0; index < parts.length - 1; index += 1) {
    const key = parts[index];
    const nextKey = parts[index + 1];

    if (cursor[key] === undefined || cursor[key] === null) {
      cursor[key] = /^\d+$/.test(nextKey) ? [] : {};
    }

    cursor = cursor[key];
  }

  cursor[parts[parts.length - 1]] = value;

  return draft;
};

const applyTaskPatch = (taskItem, patch) => {
  if (!taskItem || !patch) return taskItem;

  if (patch.type === "task-replaced" && patch.task) {
    return patch.task;
  }

  if (patch.type === "task-deleted") {
    return null;
  }

  if (patch.path) {
    return setByPath(taskItem, patch.path, patch.value);
  }

  return taskItem;
};

const getAllTaskReducer = (state = getAllTaskInitialState, action) => {
  switch (action.type) {
    case "FETCH_GETALLTASK_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
        activeRequestId: action.meta?.requestId ?? state.activeRequestId,
      };

    case "FETCH_GETALLTASK_SUCCESS": {
      if (
        action.meta?.requestId &&
        action.meta.requestId !== state.activeRequestId
      ) {
        return state;
      }

      const newUsers = action.payload?.users ?? [];

      return {
        ...state,
        loading: false,
        error: null,
        users: applySorting(newUsers, state),
        currentPage: action.payload?.currentPage ?? state.currentPage,
        totalPages: action.payload?.totalPages ?? state.totalPages,
        itemsPerPage: action.payload?.itemsPerPage ?? state.itemsPerPage,
        activeRequestId: null,
      };
    }

    case "FETCH_GETALLTASK_FAILURE": {
      if (
        action.meta?.requestId &&
        action.meta.requestId !== state.activeRequestId
      ) {
        return state;
      }

      return {
        ...state,
        loading: false,
        error: action.payload,
        activeRequestId: null,
      };
    }

    case "TASK_PATCH_RECEIVED": {
      const patch = action.payload || {};
      const taskId = patch.taskID || patch.taskId;

      if (!taskId) return state;

      const nextUsers = state.users
        .map((item) => {
          if (String(item._id) !== String(taskId)) return item;
          return applyTaskPatch(item, patch);
        })
        .filter(Boolean);

      return {
        ...state,
        users: applySorting(nextUsers, state),
      };
    }

    case "TASK_REPLACE_RECEIVED": {
      const task = action.payload;

      if (!task?._id) return state;

      const exists = state.users.some(
        (item) => String(item._id) === String(task._id)
      );

      const nextUsers = exists
        ? state.users.map((item) =>
            String(item._id) === String(task._id) ? task : item
          )
        : [task, ...state.users];

      return {
        ...state,
        users: applySorting(nextUsers, state),
      };
    }

    case "TASK_DELETE_RECEIVED": {
      const taskID = action.payload?.taskID;

      if (!taskID) return state;

      return {
        ...state,
        users: state.users.filter((item) => String(item._id) !== String(taskID)),
      };
    }

    case "SET_PAGE_TABLE":
      return {
        ...state,
        currentPage: action.payload.currentPage,
      };

    case "SORT_BY_DATE": {
      const asc = !state.task_deadlines;

      const users = [...state.users].sort((a, b) => {
        const A = parseDate(firstTask(a).endDate);
        const B = parseDate(firstTask(b).endDate);
        return asc ? A - B : B - A;
      });

      return {
        ...state,
        users,
        task_deadlines: asc,
        prioritet: false,
        price: false,
        status: false,
      };
    }

    case "SORT_BY_PRIORITET": {
      const asc = !state.prioritet;

      const order = {
        Критический: 3,
        Важно: 2,
        Срочно: 1,
        Низший: 0,
      };

      const users = [...state.users].sort((a, b) => {
        const A = order[firstTask(a).prioritet] ?? -1;
        const B = order[firstTask(b).prioritet] ?? -1;
        return asc ? A - B : B - A;
      });

      return {
        ...state,
        users,
        prioritet: asc,
        task_deadlines: false,
        price: false,
        status: false,
      };
    }

    case "SORT_BY_STATUS": {
      const asc = !state.status;

      const order = {
        Новая: 5,
        Возвращена: 4,
        Выполняется: 3,
        Выполнена: 2,
        Отменено: 1,
        Закрыта: 0,
      };

      const users = [...state.users].sort((a, b) => {
        const A = order[firstTask(a).status] ?? -1;
        const B = order[firstTask(b).status] ?? -1;
        return asc ? A - B : B - A;
      });

      return {
        ...state,
        users,
        status: asc,
        task_deadlines: false,
        prioritet: false,
        price: false,
      };
    }

    case "SORT_BY_PRICE": {
      const asc = !state.price;

      const users = [...state.users].sort((a, b) => {
        const A = Number(firstTask(a).price || 0);
        const B = Number(firstTask(b).price || 0);
        return asc ? A - B : B - A;
      });

      return {
        ...state,
        users,
        price: asc,
        task_deadlines: false,
        prioritet: false,
        status: false,
      };
    }

    default:
      return state;
  }
};

export default getAllTaskReducer;